import React from 'react';

import {
  ChangeLifestylesFiltersFunc,
  FetchLifestylesFilters
} from '../../../../../../lifestyles/lifestylesTypes';

import {
  CACHE_FETCH_SHOW_LIFESTYLE_IMAGE_QUERY,
  CacheFetchShowLifestyleImageQueryResponse
} from '../../../../../../lifestyles/queries/fetchCacheShowLifestyleImage.query';
import {
  FETCH_SHOW_LIFESTYLE_IMAGE_QUERY,
  FetchShowLifestyleImageQueryResponse
} from '../../../../../../lifestyles/queries/fetchShowLifestyleImage.query';

import { useThreeDStockLifestylesSearch } from '../../../../../pages/ThreeDStockLifestyles/hooks/useThreeDStockLifestylesSearch';
import { useCacheLifestyle } from '../../../../../../lifestyles/hooks/useCacheLifestyle';
import { useShowToastOnErrorChange } from '../../../../../../../common/hooks/useShowToastOnErrorChange';

import {
  FileAttachmentItemImageVersions,
  ImageHelper
} from '../../../../../../../helpers/ImageHelper';
import { PureButtonHelper } from '../../../../../../../helpers/buttons/PureButtonHelper';

import { words } from '../../../../../../../locales/keys';

import { LifestyleCache } from '../../../../../../lifestyles/LifestyleCache';

interface ThreeDStockLifestylesFiltersLifestyleFilterBadgeProps {
  lifestylesFilters: FetchLifestylesFilters;
  changeLifestylesFilters: ChangeLifestylesFiltersFunc;
}

function ThreeDStockLifestylesFiltersLifestyleFilterBadge({
  lifestylesFilters,
  changeLifestylesFilters
}: ThreeDStockLifestylesFiltersLifestyleFilterBadgeProps) {
  const lifestyleNanoId = lifestylesFilters?.similarLifestyle?.lifestyleId;

  const { lifestyle, lifestyleError } = useCacheLifestyle<
    | CacheFetchShowLifestyleImageQueryResponse
    | FetchShowLifestyleImageQueryResponse
  >({
    cacheKey: LifestyleCache.showImageCacheKey(),
    cacheQuery: CACHE_FETCH_SHOW_LIFESTYLE_IMAGE_QUERY,
    lifestyleNanoId,
    query: FETCH_SHOW_LIFESTYLE_IMAGE_QUERY,
    options: {
      enabled: !!lifestyleNanoId,
      enabledPlaceholder: false
    }
  });

  useShowToastOnErrorChange({
    error: lifestyleError
  });

  const { onClearSearchSimilarImage } = useThreeDStockLifestylesSearch({
    changeLifestylesFilters
  });

  if (!lifestyle) {
    return null;
  }

  return (
    <div className="p-4">
      <div className="relative">
        <ImageHelper
          className="w-full h-auto rounded-lg shadow-sm"
          src={lifestyle.image?.file}
          alt="imageSearch"
          version={FileAttachmentItemImageVersions.MiniThumb640x640}
          tooltipAlt
          tooltipAltInteractive
          tooltipAltAppendToBody
        />

        <div className="absolute bottom-0 right-0 p-2">
          <PureButtonHelper
            dataGa="clear-search-similar-image-button"
            className="py-1 pl-2 pr-2 rounded-full inline-flex items-center whitespace-nowrap text-sm font-medium leading-5 focus:ring-base text-gray-900 bg-white hover:bg-gray-100 shadow-sm hover:shadow-md transition-colors duration-150 ease-out"
            onClick={onClearSearchSimilarImage}
            i18nText={words.clear}
          />
        </div>
      </div>
    </div>
  );
}

export default ThreeDStockLifestylesFiltersLifestyleFilterBadge;
